import { render, staticRenderFns } from "./priceDetails.vue?vue&type=template&id=f8ca0d26&scoped=true"
import script from "./priceDetails.vue?vue&type=script&lang=js"
export * from "./priceDetails.vue?vue&type=script&lang=js"
import style0 from "./priceDetails.vue?vue&type=style&index=0&id=f8ca0d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ca0d26",
  null
  
)

export default component.exports